import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import CountryService from "../../../../services/catalogs/CountryService";

export const REQUEST_FETCH_COUNTRIES = "REQUEST_FETCH_COUNTRIES";
export const FETCH_COUNTRIES_SUCCESS = "FETCH_COUNTRIES_SUCCESS";
export const FETCH_COUNTRIES_ERROR = "FETCH_COUNTRIES_ERROR";

function requestFetchCountries() {
  return {
    type: REQUEST_FETCH_COUNTRIES,
  };
}

function fetchCountriesSuccess(json) {
  return {
    type: FETCH_COUNTRIES_SUCCESS,
    countries: json.data,
  };
}

function fetchCountriesError(json) {
  return {
    type: FETCH_COUNTRIES_ERROR,
    error: json.data,
  };
}

export function fetchCountries(searchWord) {
  return (dispatch) => {
    dispatch(requestFetchCountries());
    return CountryService.getCountries(searchWord).then((json) => {
      if (json.data.code === 200) {
        dispatch(fetchCountriesSuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(fetchCountries(searchWord));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(fetchCountriesError(json.data));
      }
    });
  };
}
